const styles = theme => ({
  container: theme.container,
  footer: {
    fontSize: theme.fontSize * 0.8,
    backgroundColor: '#19426C',
    padding: '40px 20px',
    '& p': {
      color: '#FFFFFF',
    },
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItem: 'center',
    gap: '40px',
  },
  footerLogo: {
    width: '100px',
    height: '41.9px',
  },
  '@media (max-width: 760px)': {
    // table: {
    //   maxHeight: '400px',
    // },
    footerContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
});

export default styles;
